import { clsx } from 'clsx';
import styles from './Toggle.scss';

interface ToggleProps extends React.HTMLProps<HTMLLabelElement> {
  isChecked: boolean;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  labelView?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const Toggle = ({ isChecked, handleChange, labelView, className, disabled, ...props }: ToggleProps) => (
  <label className={clsx(styles.wrapper, className)} {...props}>
    <input type="checkbox" checked={isChecked} className={styles.input} disabled={disabled} onChange={handleChange} />
    <div className={clsx(styles.toggleContainer, isChecked && styles.checked, disabled && styles.disabled)}>
      <div className={styles.toggleBall} />
    </div>
    {labelView && <span className={styles.text}>{labelView}</span>}
  </label>
);

export default Toggle;
